import { History } from "history";
import { localStorageService } from "../util/localStorageService";
import { differenceInMinutes } from "date-fns";
import { useEffect, useRef } from "react";
import { NotIdle } from "idlejs";
import { AuthManager } from "../auth/Auth";

const TIMEOUT: number = 240;

export const useLogoutWhenInactive = (
  authProvider: AuthManager,
  history: History
) => {
  const idleRef = useRef<NotIdle>();

  useEffect(() => {
    authProvider
      .checkAuth(null)
      .then(() => {
        idleRef.current = new NotIdle();
        idleRef.current
          .whenInteractive()
          .within(1)
          .do(() => localStorageService.setLastActivity())
          .start();
      })
      .catch(() => {
        console.debug("Not logged in, not triggering idle check");
      });

    return () => {
      idleRef.current?.stop();
    };
  }, [history, authProvider]);

  useEffect(() => {
    const logoutIfIdle = async () => {
      try {
        await authProvider.checkAuth();
        const lastActivity = localStorageService.getLastActivity();
        if (differenceInMinutes(new Date(), lastActivity) >= TIMEOUT) {
          console.log("Logging out due to inactivity", new Date());
          history.push("/logout");
        }
      } catch {
        console.debug("Not logged in, not triggering idle check");
      }
    };

    const interval = setInterval(logoutIfIdle, 1000);
    return () => clearInterval(interval);
  }, [authProvider, history]);
};
